/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable no-unused-expressions */
import React, { useContext, useRef, useState, useEffect } from "react";
import { Col, Row } from "../../components/Grid";
import { Field, Form, Formik } from "formik";
import moment from 'moment';
import {
  RowOrderFilter,
  CalendarContainer,
  FilterSearchContainer,
  RowFilterIcon,
  FilterContainer,
  RowFilter,
  CheckBoxColumn,
  FilterColumn,
  ColIcon,
  FilterLabel,
} from "./styles";
import DateRangePicker from '../../components/DateRangePicker';
import { useGetStatusOptions, useGetQuestionnairesById } from "../../services/QuestionnairesService";
import Icon from "../../components/Icon";
import { flatten } from "lodash";
import { useHistory } from "react-router-dom";

import {
  InputField,
  Label,
  CheckBox,
  MultiSelectField,
  ComboBox
} from '@fitinsur/components';
import SaveFilters from "../../components/SaveFiltersGlobal";
import { useGetQuery } from '@fitinsur/services/QuestionnairesService';

const ListHeader = ({ 
  filterData, listUrl, availabelStatuses,
  setFilterData, listNameSpace, onHandleFilter,
  optionsModalities, optionsProduct, optionsBroker,
  optionsSla, exportList, idDomainList,
  idApplication, optionsStatus
}) => {
  const formik = useRef(null);
  const history = useHistory();
  const [showFilter, setShowFilter] = useState(false);
  const [showCalendar, setShowCalendar] = useState(false);
  const [searchList, setSearchList] = useState({});
  const [filterNameSelected, setFilterNameSelected] = useState("DEFAULT");
  const [initialValues, setInitialValues] = useState({
    ...filterData.reduce((a, b) => {
      a[b.key] = b.value || '';

      if (b.type === 'date' && b.value?.length) {
        const from = moment(b.value[0]).format("MM/DD/YYYY");
        const to = moment(b.value[1]).format("MM/DD/YYYY");
        a[b.key] = `${from} - ${to}`;
      }

      return a;
    }, {})
  });

  const idDomainsStatusMapped = availabelStatuses || [];

  const {
    request: getStatusOptionsRequest,
  } = useGetStatusOptions();

  const {
    data: getQuestionnairesData,
    request: getQuestionnairesRequest
  } = useGetQuestionnairesById(81);

  const {
    request: useGetQueryRequest,
  } = useGetQuery();


  const searchRequest = async (searchValue, searchQueryId) => {
    try {

      if (searchQueryId === 'hierarchy') {
        searchList[searchQueryId] = [
          { label: "Grupo Econômico", value: "holding" },
          { label: "Filial", value: "legal_entity" },
          { label: "Individual", value: "individual" }
        ];

        return setSearchList(searchList);
      } else if (searchQueryId === 'broker' || searchQueryId === 'brokers' || searchQueryId === 'nmBroker' || searchQueryId === 'sompoBroker') {
        await new Promise(resolve => setTimeout(() => resolve(), 1000))
        searchList[searchQueryId] = optionsBroker || [];
        return setSearchList(searchList);
      } else if (searchQueryId === 'idDomainStatus' || searchQueryId === 'endorsementStatus' || searchQueryId === "status") {
        await new Promise(resolve => setTimeout(() => resolve(), 1000))
        searchList[searchQueryId] = optionsStatus || [];
        return setSearchList(searchList);
      } else if (searchQueryId == "product" || searchQueryId === "productName") {
        await new Promise(resolve => setTimeout(() => resolve(), 1000))
        searchList[searchQueryId] = optionsProduct || [];
        return setSearchList(searchList);
      } else if (searchQueryId == "modality") {
        await new Promise(resolve => setTimeout(() => resolve(), 1000))
        searchList[searchQueryId] = optionsModalities || [];
        return setSearchList(searchList);
      } else if (searchQueryId === 'sla') {
        searchList[searchQueryId] = optionsSla || [];

        return setSearchList(searchList);
      }
      return;
    } catch (err) {
      console.log("FETCH_FAILURE: ", err);
      return;
    }
  }

  useEffect(() => {
    getQuestionnairesRequest();
    const getLists = async () => {
      for (const filter of filterData) {
        await new Promise(resolve => setTimeout(() => resolve(), 300));
        async () => await searchRequest(null, filter.key);
      }
    }
    getLists()
  }, [])

  useEffect(() => {
    searchList["product"] = optionsProduct;
    searchList["productName"] = optionsProduct;
    setSearchList(searchList);
  }, [optionsProduct]);

  useEffect(() => {
    searchList["modality"] = optionsModalities;
    setSearchList(searchList);
  }, [optionsModalities]);

  useEffect(() => {
    searchList["broker"] = optionsBroker;
    searchList["brokers"] = optionsBroker;
    searchList["nmBroker"] = optionsBroker;
    searchList["sompoBroker"] = optionsBroker;
    setSearchList(searchList);
  }, [optionsBroker]);


  useEffect(() => {
    searchList["sla"] = optionsSla;
    
    setSearchList(searchList);
  }, [optionsSla]);


  useEffect(() => {
    if(optionsStatus) { 
      searchList["idDomainStatus"] = optionsStatus;
      searchList["endorsementStatus"] = optionsStatus;
      searchList["status"] = optionsStatus;
      
      setSearchList(searchList);
    }
  }, [optionsStatus]);


  useEffect(() => {
    const questions = getQuestionnairesData?.value?.operations?.length ? getQuestionnairesData.value.operations.find(item => item.idQuestion == 1551 || item.idQuestion == 1552) : []
    const answerOptions = [];
    if (questions.length) {
      for (const question of questions) {
        question.answerOptions.map(item => answerOptions.push({
          label: item.dsAnswerOption,
          value: item.idAnswerOption
        }))
      }
      searchList["modality"] = answerOptions;
    }

  }, [getQuestionnairesData])

  const showRangeDate = (fieldKey) => {
    const from = formik.current?.values[fieldKey]?.from ? new Date(formik.current.values[fieldKey].from).toLocaleDateString("pt-BR") : "";
    const to = formik.current?.values[fieldKey]?.to ? new Date(formik.current.values[fieldKey].to).toLocaleDateString("pt-BR") : "";

    if (!from && !to) return ""
    return `${from} - ${to}`;
  };


  useEffect(() => {
    handleFilerChange(filterData)
  }, []);

  const handleFilterStore = async (filterData) => {
    localStorage.setItem(`${listNameSpace}`, JSON.stringify(filterData))
    let str = ''
    filterData.map((item, index) => {
      if (item.value) {
        str = str + item.key + '=' + item.value
      }
      if (filterData[index + 1] && filterData[index + 1].value) {
        str += '&'
      } else {
        str += ''
      }
    })
    history.push(`${listUrl}?${str}`)
    localStorage.setItem(`str-${listNameSpace}`, str)
  }

  const handleFilerChange = async (filter) => {
    formik.current?.setValues({});
    await new Promise(resolve => setTimeout(() => resolve(), 300));
    handleFilterStore(filter);
    for (const f of filter) {
      if (f.type === "date" && f.value?.length) {
        const from = moment(f.value[0]).format("MM/DD/YYYY");
        const to = moment(f.value[1]).format("MM/DD/YYYY");
        formik.current && formik.current.setFieldValue(f.key, `${from} - ${to}`);
      } else if (f.type === "range") {
        if (f.value?.length) {
          formik.current && formik.current.setFieldValue(`${f.key}.to`, f.value[1]);
          formik.current && formik.current.setFieldValue(`${f.key}.from`, f.value[0]);
        } else {
          formik.current && formik.current.setFieldValue(`${f.key}`, "");
        }
      } else {
        formik.current && formik.current.setFieldValue(f.key, f.value);
      }
    }
  }

  return (
    <>
      <RowFilterIcon>
        <FilterContainer className={showFilter ? "filter-open" : "filter-close"}>
          <Row>
            <Col
              style={{
                display: "flex",
                justifyContent: "flex-end",
                padding: "5px 0 5px 0",
              }}
            >
              <Icon
                name="close"
                className="icon-close"
                onClick={() => setShowFilter(false)}
              />
            </Col>
          </Row>

          <hr className="d-md-none mb-3" />

          <FilterSearchContainer>
            <SaveFilters
              filterData={filterData}
              onHandleFilter={() => {
                onHandleFilter()
                handleFilterStore(filterData)
              }}
              setShowFilter={setShowFilter}
              idDomain={idDomainList}
              idDomainApplication={idApplication}
              onCleanFilter={() => {
                setFilterData(
                  filterData.map((filter) => {
                    formik.current && formik.current.setFieldValue(filter.key, "");
                    return { ...filter, value: null };
                  })
                );
              }}
              onFilterChange={(filter, filterName) => {
                setFilterData(filter)
                handleFilerChange(filter)
                setFilterNameSelected(filterName);
              }}
            >
              <Formik
                innerRef={formik}
                onSubmit={(values) => {
                }}
                initialValues={initialValues}
                enableReinitialization={true}
              >
                {formikProps => {
                  return (
                    <Form>
                      {filterData.map((filter, filterIndex) => {
                        return (
                          <RowFilter>
                            <CheckBoxColumn>
                              <Label>
                                <CheckBox
                                  checked={formikProps.values[filter.key]}
                                  onClick={() => {
                                    setFilterData(filterData.map((v, i) => v.key === filter.key ? { ...v, value: "" } : v));
                                    formik.current.setFieldValue(filter.key, "")
                                    if (filter.type === "date") {
                                      formik.current.setFieldValue('dateRangeTo', "");
                                      formik.current.setFieldValue('dateRangeFrom', "");
                                    }
                                  }}
                                />
                              </Label>
                            </CheckBoxColumn>
                            <FilterColumn>
                              {filter.type === "text" && (
                                <Field
                                  name={filter.key}
                                  placeholder={filter.label}
                                  component={InputField}
                                  type="text"
                                  validation={false}
                                  value={filter.value}
                                  onChange={(e) => {
                                    setFilterData(filterData.map((v, i) => v.key === filter.key ? { ...v, value: e } : v));
                                    formikProps.setFieldValue(filter.key, e);
                                  }}
                                  filter={true}
                                />
                              )}

                              {filter.type === "range" &&
                                <div style={{ display: 'flex', width: '100%', justifyContent: 'flex-start', gap: '1rem' }}>
                                  <Field
                                    name={`${filter.key}.from`}
                                    placeholder={`${filter.label} DE`}
                                    component={InputField}
                                    type="text"
                                    onChange={(e) => {
                                      setFilterData(
                                        filterData.map((v, i) =>
                                          v.key === filter.key
                                            ? { ...v, value: v.value ? [e, v.value[1]] : [e] }
                                            : v
                                        )
                                      );
                                      formikProps.setFieldValue(`${filter.key}.from`, e);
                                    }}
                                    validation={false}
                                    filterField={true}
                                  />

                                  <Field
                                    name={`${filter.key}.to`}
                                    placeholder={`${filter.label} ATÉ`}
                                    component={InputField}
                                    type="text"
                                    onChange={(e) => {
                                      setFilterData(
                                        filterData.map((v, i) =>
                                          v.key === filter.key
                                            ? { ...v, value: v.value ? [v.value[0], e] : [null, e] }
                                            : v
                                        )
                                      );
                                      formikProps.setFieldValue(`${filter.key}.to`, e);
                                    }}
                                    validation={false}
                                    filterField={true}
                                  />
                                </div>
                              }


                              {filter.type === "list" && (
                                <Field
                                  name={filter.key}
                                  placeholder={filter.label}
                                  component={ComboBox}
                                  options={
                                    filter.options || searchList[filter.key] || []
                                  }
                                  type="text"
                                  validation={false}
                                  style={{ marginBottom: '15px' }}
                                  value={filter.value}
                                  onChange={(e) => {
                                    setFilterData(filterData.map((v, i) => v.key === filter.key ? { ...v, value: e } : v));
                                    formikProps.setFieldValue(filter.key, e);
                                  }}
                                  onOpen={() =>
                                    searchRequest(null, filter.key)
                                  }
                                  filter={true}
                                  filterField={true}
                                />
                              )}

                              {filter.type === "multi-list" && (
                                <Field
                                  name={filter.key}
                                  placeholder={filter.label}
                                  component={MultiSelectField}
                                  options={
                                    searchList[filter.key] || []
                                  }
                                  type="text"
                                  validation={false}
                                  value={filter.value}
                                  style={{ marginBottom: '15px' }}
                                  onChange={(e) => {
                                    if (!e?.length) e = "";
                                    setFilterData(filterData.map((v, i) => v.key === filter.key ? { ...v, value: e } : v));
                                    formikProps.setFieldValue(filter.key, e);
                                  }}
                                  format={(value) => {
                                    if (searchList && searchList[filter.key]) {
                                      const selectedItems = searchList[filter.key]?.filter((option) => value.includes(option.value)) || [];
                                      return selectedItems.map((item) => item.label).join(", ");
                                    }
                                  }}
                                  onOpen={() =>
                                    searchRequest(null, filter.key)
                                  }
                                  filter={true}
                                  filterField={true}
                                />
                              )}

                              {filter.type ===
                                "multi-list-array" && (
                                  <Field
                                    name={filter.key}
                                    placeholder={filter.label}
                                    component={MultiSelectField}
                                    options={searchList[filter.key] || []}
                                    type="text"
                                    validation={false}
                                    style={{ marginBottom: '15px' }}
                                    value={filter.value}
                                    onChange={(e) => {
                                      if (!e?.length) e = "";
                                      setFilterData(filterData.map((v, i) => v.key === filter.key ? { ...v, value: flatten(e), } : v));
                                      formikProps.setFieldValue(filter.key, e);
                                    }}
                                    format={(value) => {
                                      const selectedItems = searchList[filter.key]?.filter((option) => flatten(value).find((v) => option.value.includes(v))) || [];
                                      return selectedItems.map((item) => item.label).join(", ");
                                    }}
                                    onOpen={() =>
                                      searchRequest(null, filter.key)
                                    }
                                    filter={true}
                                    filterField={true}
                                  />
                                )}

                              {filter.type === "date" && (
                                <Field
                                  name={filter.key}
                                  placeholder={filter.label}
                                  rightIcon="calendar"
                                  rightIconClick={() => {
                                    setShowCalendar(filter.key);
                                  }}
                                  component={InputField}
                                  type="text"
                                  validation={false}
                                  customValue={showRangeDate(filter.key)}
                                  filter={true}
                                  readOnly
                                  filterField={true}
                                />
                              )}
                              {showCalendar &&
                                showCalendar === filter.key && (
                                  <CalendarContainer>
                                    <DateRangePicker
                                      initialRange={{ from: formikProps.values[filter.key]?.from, to: formikProps.values[filter.key]?.to }}
                                      onChange={(range) => {
                                        setFilterData(
                                          filterData.map((v, i) =>
                                            v.key === filter.key
                                              ? {
                                                ...v,
                                                value: [
                                                  range.from,
                                                  range.to,
                                                ],
                                              }
                                              : v
                                          )
                                        );

                                        formikProps.setFieldValue(`${[filter.key]}.from`, range.from);
                                        formikProps.setFieldValue(`${[filter.key]}.to`, range.to);

                                        if (range.from && range.to) {
                                          setShowCalendar("");
                                          formikProps.setFieldValue(`dateRangeFrom`, range.from);
                                          formikProps.setFieldValue(`dateRangeTo`, range.to);
                                        }
                                      }}
                                    />
                                  </CalendarContainer>
                                )}
                            </FilterColumn>
                          </RowFilter>
                        );
                      })}
                    </Form>
                  );
                }}
              </Formik>
            </SaveFilters>
          </FilterSearchContainer>
        </FilterContainer>

        <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
          <FilterLabel>
            {filterNameSelected ? <b>FILTER: {filterNameSelected}</b> : ''}
          </FilterLabel>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <ColIcon>
              <Icon
                title="Exportar para Excel"
                name="exportExcel"
                onClick={() => exportList()}
              />
            </ColIcon>
            <ColIcon>
              <Icon
                title="Filtrar"
                name="filter"
                onClick={() => setShowFilter(!showFilter)}
              />
            </ColIcon>
            <ColIcon>
              <Icon
                title="Limpar Filtros"
                name="filterCan"
                onClick={(e) => {
                  setFilterData(
                    filterData.map((filter) => {
                      formik.current && formik.current.setFieldValue(filter.key, "");
                      return { ...filter, value: null };
                    })
                  );
                  setShowFilter(false);
                  onHandleFilter(true);
                }}
              />
            </ColIcon>
          </div>
        </div>
      </RowFilterIcon>

      <RowOrderFilter>{ }</RowOrderFilter>
    </>
  );
};

export default ListHeader;
